import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=1934f580&scoped=true&"
import script from "./StudyCourse.vue?vue&type=script&lang=js&"
export * from "./StudyCourse.vue?vue&type=script&lang=js&"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=1934f580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934f580",
  null
  
)

export default component.exports